<div #informationCardContainer class="policy">
  <div (click)="onClick()"
       [ngClass]="{ 'border-none': compData?.hideBorder }"
       class="info-card info-card-{{ compData?.container?.type }}">
    <div class="flex-container ion-align-items-center ion-justify-content-between box-info">
      @if (compData?.container?.title) {
        <h2 class="title">
          {{ compData?.container?.title | titlecase }}
        </h2>
      }
      <div>
        <ng-content select="[rightTitleSection]"></ng-content>
      </div>
    </div>
    <!--<div *ngIf="compData?.container?.subTitle" class="sub-title font-bold">
    {{((readMore) ? compData?.container?.subTitle : compData?.container?.subTitle | slice:0:50) | titlecase}}
    <a href="javascript:void(0)" (click)="readMore = !readMore">
      <ng-container *ngIf="readMore">See Less</ng-container>
      <ng-container *ngIf="!readMore">See More</ng-container>
    </a>
  </div>-->
    @if (compData?.container?.subTitle) {
      <div class="sub-title">
      <span [ngClass]="{ 'read-less': !readMore, 'read-more': readMore }"
            [style.line-clamp]="compData?.container?.clampRow"
            [style.-webkit-line-clamp]="compData?.container?.clampRow">
        {{ compData?.container?.subTitle | toParagraph }}
      </span>
        @if (compData?.container?.clampRow > 0) {
          <span class="see-more-btn" (click)="readMore = !readMore">
          @if (readMore) {
            See Less
          }
            @if (!readMore) {
              See More
            }
        </span>
        }
      </div>
    }

    @if (compData?.container?.description) {
      <div class="description">
        <div [innerHTML]="(compData?.container?.description | toParagraph) | safe: 'html'"
             class="inner-html-text"></div>
      </div>
    }
  </div>
</div>
